export default "__VITE_ASSET__CICpHbHh__"